import React from 'react';
import { Typography } from '@mui/material';
import './SummarySection.css';

const isAnyProperties = (table) => {
  const keys = Object.getOwnPropertyNames(table);
  for (let i = 0; i < keys.length; i += 1) {
    if (table[keys[i]]) return true;
  }
  return false;
};

const SummarySection = (props) => {
  if (!isAnyProperties(props.table)) {
    return null;
  }
  return (
    <div className="SummarySection">
      <Typography variant="subtitle1">{props.title}</Typography>
      <div>
        {Object.getOwnPropertyNames(props.table).map((key, index) => {
          if (props.table[key]) {
            return (
              // eslint-disable-next-line react/no-array-index-key
              <div className="SummarySection-container" key={index}>
                <div className="SummarySection-left">
                  <Typography>{`${key}: `}</Typography>
                </div>
                <div className="SummarySection-right">
                  <Typography>{props.table[key]}</Typography>
                </div>
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

export default SummarySection;
